import {
    useGetDMaxCommon,
    type AroundDmaxInfoResponse,
    type Aside1DmaxInfoResponse,
    type GuideDmaxInfoResponse,
    type MainInfoDmaxResponse,
    type RefundDmaxInfoResponse,
} from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { Aside1Section, GuideDetail, Refund, TopSection, Travel } from "../common";

export const Guide = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: guide } = useGetDMaxCommon<GuideDmaxInfoResponse>({ section: "guide" });
    const { data: aside1 } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    const { data: refund } = useGetDMaxCommon<RefundDmaxInfoResponse>({ section: "refund" });
    return main && guide && aside1 && refund ? (
        <>
            <TopSection imgList={main.imgList} sector={main.sector} />
            <Center w="100%" flexDir="column">
                <GuideDetail data={guide} />
                <Refund refunds={refund} />
            </Center>
            <Aside1Section data={aside1} />
            {around?.isUse && <Travel data={around} />}
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
